/* ============================================================
   <res-fc-slider> — carrossel das vitrines (res-featured-collection)

   data-cols-desktop / data-cols-mobile  colunas por breakpoint
   data-autoplay / data-autoplay-delay   autoplay (ms)
   data-full-width                       modo "sangrando" à direita

   Setas: qualquer elemento com [data-slider-prev] / [data-slider-next]
   dentro do componente.
   ============================================================ */
if (!customElements.get('res-fc-slider')) {
  class ResFcSlider extends HTMLElement {
    connectedCallback() {
      if (window.Swiper) {
        this.init();
      } else {
        window.addEventListener('load', () => this.init(), { once: true });
      }
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    init() {
      const container = this.querySelector('.swiper');
      if (!container || this.swiper || !window.Swiper) return;

      const colsDesktop = Number(this.dataset.colsDesktop) || 4;
      const colsMobile = Number(this.dataset.colsMobile) || 2;
      const fullWidth = this.hasAttribute('data-full-width');
      const slideCount = container.querySelectorAll('.swiper-slide').length;

      // Loop só funciona com slides sobrando; com poucos produtos o Swiper trava
      const autoplay = this.hasAttribute('data-autoplay');
      const loop = autoplay && slideCount >= colsDesktop * 2;

      // No modo largura total o container tem padding-left; sem um respiro
      // equivalente à direita o último card fica colado/cortado na borda
      // e, quando todos "cabem", o Swiper trava as setas.
      const offsetAfter = () => (fullWidth ? parseFloat(getComputedStyle(container).paddingLeft) || 0 : 0);

      const config = {
        slidesPerView: 1.4,
        spaceBetween: 16,
        loop,
        watchOverflow: true,
        slidesOffsetAfter: offsetAfter(),
        navigation: {
          prevEl: Array.from(this.querySelectorAll('[data-slider-prev]')),
          nextEl: Array.from(this.querySelectorAll('[data-slider-next]')),
        },
        breakpoints: {
          750: { slidesPerView: colsMobile, spaceBetween: 20 },
          990: { slidesPerView: colsDesktop, spaceBetween: 24 },
        },
        on: {
          afterInit: (swiper) => this.syncLock(swiper),
          breakpoint: (swiper) => this.syncLock(swiper),
          resize: (swiper) => {
            swiper.params.slidesOffsetAfter = offsetAfter();
            swiper.update();
            this.syncLock(swiper);
          },
        },
      };

      if (autoplay) {
        config.autoplay = {
          delay: Number(this.dataset.autoplayDelay) || 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      this.swiper = new window.Swiper(container, config);
    }

    // Quando todos os produtos cabem na tela, trava o arraste e esconde as setas
    // (o slidesOffsetAfter deixaria o Swiper "andar" só o tamanho do respiro).
    syncLock(swiper) {
      const perView = swiper.params.slidesPerView;
      const fits = typeof perView === 'number' && swiper.slides.length <= perView;

      if (fits) swiper.slideTo(0, 0);
      swiper.allowSlideNext = !fits;
      swiper.allowSlidePrev = !fits;
      swiper.allowTouchMove = !fits;

      this.querySelectorAll('[data-slider-prev], [data-slider-next]').forEach((button) => {
        button.classList.toggle('swiper-button-lock', fits);
      });
    }
  }

  customElements.define('res-fc-slider', ResFcSlider);
}
